export const MAX_EXPORT_DAYS = 7;

export function formatLocalISODate(date = new Date()) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function addDaysToISODate(isoDate, dayOffset) {
  const [year, month, day] = String(isoDate).split('-').map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + dayOffset);
  return formatLocalISODate(date);
}

/** Earliest selectable day: today inclusive of the last MAX_EXPORT_DAYS window. */
export function getExportEarliestDate(today = formatLocalISODate()) {
  return addDaysToISODate(today, -(MAX_EXPORT_DAYS - 1));
}

export function inclusiveDayCount(startDate, endDate) {
  const [sy, sm, sd] = String(startDate).split('-').map(Number);
  const [ey, em, ed] = String(endDate).split('-').map(Number);
  const start = new Date(sy, sm - 1, sd);
  const end = new Date(ey, em - 1, ed);
  const diffMs = end.getTime() - start.getTime();
  return Math.floor(diffMs / 86400000) + 1;
}

export function clampExportDateRange(startDate, endDate, today = formatLocalISODate()) {
  const earliest = getExportEarliestDate(today);
  let start = startDate || '';
  let end = endDate || '';

  if (start && start > today) {
    start = today;
  }
  if (end && end > today) {
    end = today;
  }
  if (start && start < earliest) {
    start = earliest;
  }
  if (end && end < earliest) {
    end = earliest;
  }

  if (start && end && start > end) {
    end = start;
  }

  if (start && end) {
    const span = inclusiveDayCount(start, end);
    if (span > MAX_EXPORT_DAYS) {
      end = addDaysToISODate(start, MAX_EXPORT_DAYS - 1);
      if (end > today) {
        end = today;
        start = addDaysToISODate(end, -(MAX_EXPORT_DAYS - 1));
      }
      if (start < earliest) {
        start = earliest;
      }
    }
  }

  return { startDate: start, endDate: end };
}

/**
 * Calendar bounds locked to the rolling last MAX_EXPORT_DAYS through today.
 * Within that window, start/end still constrain each other for shorter ranges.
 */
export function getExportDateBounds(startDate, endDate, today = formatLocalISODate()) {
  const earliest = getExportEarliestDate(today);

  let startMin = earliest;
  let startMax = today;
  let endMin = earliest;
  let endMax = today;

  if (endDate) {
    const relativeMin = addDaysToISODate(endDate, -(MAX_EXPORT_DAYS - 1));
    startMin = relativeMin > earliest ? relativeMin : earliest;
    startMax = endDate < today ? endDate : today;
  }

  if (startDate) {
    const relativeMax = addDaysToISODate(startDate, MAX_EXPORT_DAYS - 1);
    endMin = startDate > earliest ? startDate : earliest;
    endMax = relativeMax < today ? relativeMax : today;
  }

  return {
    startMin,
    startMax,
    endMin,
    endMax,
    today,
    earliest,
  };
}
